import { Route, Routes, useLocation } from 'react-router-dom-6';

import TokenViewApp from './index';

import NotFound from './Pages/404';

import { FormikHelper } from '$HVUI';

const isUUID = str => {
    return /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(
        str
    );
};

const UUIDRoute = () => {
    const { pathname } = useLocation();
    const path = pathname.replaceAll('/', '');
    const match = isUUID(path);
    return match ? <TokenViewApp /> : <NotFound />;
};

const App = () => {
    return (
        <FormikHelper>
            <Routes>
                <Route path="/:token" Component={UUIDRoute} />
                <Route path="*" Component={NotFound} />
            </Routes>
        </FormikHelper>
    );
};

export default App;
